import { NumberInput, NumberInputProps, TextInput, TextInputProps } from '@mantine/core'
import React from 'react'


interface Props extends NumberInputProps {
    acceptOnlyDigit?: boolean
}

export function ENumberInput(props: Props) {
    return (
        <NumberInput
            allowNegative={false}
            label={props.label}
            styles={{
                input: {
                    borderRadius: '8px',
                    fontSize: '17px',
                },
                label: {
                    marginBottom: '2px',
                    fontWeight: 400,
                    fontSize: '15px',
                    color: '#374151',
                },
                error: {
                    fontSize: '12px',
                    marginTop: '4px',
                },
                ...props.styles as any,
            }}
            size={props.size}
            required={props.required}
            className={props.className}
            description={props.description}
            hideControls={props.hideControls ? props.hideControls : true}
            value={props.value || ""}
            max={props.max}
            min={props.min ? props.min : 0}
            maxLength={props.maxLength ? props.maxLength : 100}
            placeholder={props.placeholder}
            error={props.error}
            right={props.right}
            onChange={props.onChange}
            {...props}
        />
    )
}
